import reduxApi, {transformers} from 'redux-api';
import customFetch from 'api/axios';
import CONFIG from 'base/constants/config';

const limit = 500;
const order = 'createdAt DESC';

let endpoins = {
  list: {
    url: `home_banners`,
    options:(url, params, getState) => {
      return {
        method: "GET",
        headers: {},
        data: {}
      };
    }
  }
}

const rest = reduxApi(endpoins)
.use('fetch', customFetch)
.use("rootUrl", CONFIG.API_URL);

export default rest;


// WEBPACK FOOTER //
// ./api/home-banners.js